module.exports = __webpack_public_path__ + "static/bgOlympo-b127acd19707ef5566125446003d2b46.jpg";